(function () {
  'use strict';
  // Pati Profili — localStorage önbellek + sepet attribute köprüsü + metaobject rehidrasyonu.
  // Kalıcı kayıt: pet_profile metaobject'leri (customer.metafields.pet_profile.pets).
  // Sitede yapılan değişiklik sepet attribute'u ile siparişe işlenir; Flow metaobject'e yazar.

  // Çeviri (theme.liquid window.PETIDI_T; Türkçede boş → varsayılan metin) + dil öneki. `tt` bu dosyada değişken adı → _t.
  var T = window.PETIDI_T || {}, KOK = window.PETIDI_KOK || '';
  function _t(k, d, o) { var s = T[k] || d; if (o) Object.keys(o).forEach(function (x) { s = s.split('[' + x + ']').join(o[x]); }); return s; }
  // Kilo sınırı: kg dışı (gram) girişi engeller. Dönüş: hata metni ya da ''.
  var KILO_MAX = { kedi: 15, kopek: 100 };
  function kiloHata(v, tur) {
    var s = String(v == null ? '' : v).trim().replace(',', '.');
    if (!s) return '';
    var n = parseFloat(s), mx = KILO_MAX[tur] || 100;
    if (isFinite(n) && n > 0 && n <= mx) return '';
    return _t('kilo_hata', 'Kiloyu kg olarak yaz (ör. 1,5). En fazla [max] kg olabilir.', { max: mx });
  }
  window.PetidiKiloHata = kiloHata;
  function _tn(k, n, d, o) { o = o || {}; o.n = n; return _t(k + (n === 1 ? '.one' : '.other'), d, o); }

  var LS_KEY = 'petidi_pet_profili';
  var ATTR_KEY = 'Pet Profili';

  var root = document.getElementById('PetProfile');
  var dataEl = document.getElementById('PetProfileData');
  if (!root || !dataEl) return;

  var boot = {};
  try { boot = JSON.parse(dataEl.textContent) || {}; } catch (e) {}

  // Tür ikonu (1 Kas 2026: emoji yerine temanın ikon seti — layout/theme.liquid window.PETIDI_IKON)
  var IK = window.PETIDI_IKON || {};
  var TUR_EMOJI = { kedi: IK.cat || '', kopek: IK.dog || '', kus: IK.paw || '', kemirgen: IK.paw || '', balik: IK.paw || '', diger: IK.paw || '' };
  var TUR_LABEL = { kedi: _t('tur_kedi', 'Kedi'), kopek: _t('tur_kopek', 'Köpek'), kus: _t('tur_kus', 'Kuş'), kemirgen: _t('tur_kemirgen', 'Kemirgen'), balik: _t('tur_balik', 'Balık'), diger: _t('tur_diger', 'Diğer') };
  // Ön tanımlı ırk listeleri — istatistik tutarlılığı için serbest metin yok
  var BREEDS = {
    kedi: ['Melez', 'Ankara Kedisi', 'Bengal', 'British Longhair', 'British Shorthair',
      'Burmese', 'Chinchilla', 'Exotic Shorthair', 'Himalayan', 'İran Kedisi (Persian)', 'Maine Coon',
      'Mavi Rus (Russian Blue)', 'Norveç Orman Kedisi', 'Ragdoll', 'Sarman', 'Scottish Fold',
      'Sfenks (Sphynx)', 'Siyam', 'Tekir', 'Van Kedisi', 'Diğer'],
    kopek: ['Melez', 'Akbaş', 'Akita', 'Alman Çoban Köpeği (Kurt)', 'Beagle',
      'Bichon Frise', 'Border Collie', 'Boxer', 'Cavalier King Charles', 'Chihuahua', 'Chow Chow',
      'Cocker Spaniel', 'Dachshund (Sosis)', 'Doberman', 'Fransız Bulldog', 'Golden Retriever',
      'İngiliz Bulldog', 'Jack Russell Terrier', 'Kangal', 'Kaniş (Poodle)', 'Labrador Retriever',
      'Maltese', 'Pekinez', 'Pomeranian', 'Pug', 'Rottweiler', 'Samoyed', 'Setter', 'Shiba Inu',
      'Shih Tzu', 'Sibirya Kurdu (Husky)', 'Terrier', 'Yorkshire Terrier', 'Diğer']
  };
  // Irk adları: KAYIT değeri her dilde Türkçe (BREEDS, istatistik tutarlılığı); yalnız görünen etiket çevrilir.
  // js.irk_kedi / js.irk_kopek = "Türkçe=Görünen|…" (değer başına 1000 karakter sınırı) (Türkçede kendisi). Listede olmayan ad olduğu gibi görünür.
  var IRK_AD = {};
  (_t('irk_kedi', '') + '|' + _t('irk_kopek', '')).split('|').forEach(function (x) { var i = x.indexOf('='); if (i > 0) IRK_AD[x.slice(0, i)] = x.slice(i + 1); });
  function irkAd(b) { return IRK_AD[b] || b; }
  var AYLAR = _t('aylar', 'Ocak,Şubat,Mart,Nisan,Mayıs,Haziran,Temmuz,Ağustos,Eylül,Ekim,Kasım,Aralık').split(',');
  var PENCIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.8 2.8 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function num(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return (n && n > 0) ? n : null;
  }

  // Metaobject'ten gelen serbest değerleri anahtara indirger ("Köpek"/"Dog" → "kopek")
  function turKey(s) {
    s = String(s || '').toLowerCase();
    if (!s) return 'diger';
    if (s.indexOf('köpek') >= 0 || s.indexOf('kopek') >= 0 || s.indexOf('dog') >= 0) return 'kopek';
    if (s.indexOf('kedi') >= 0 || s.indexOf('cat') >= 0) return 'kedi';
    if (s.indexOf('kuş') >= 0 || s.indexOf('kus') >= 0 || s.indexOf('bird') >= 0) return 'kus';
    if (s.indexOf('kemirgen') >= 0 || s.indexOf('hamster') >= 0 || s.indexOf('tavşan') >= 0 || s.indexOf('rodent') >= 0 || s.indexOf('rabbit') >= 0) return 'kemirgen';
    if (s.indexOf('balık') >= 0 || s.indexOf('balik') >= 0 || s.indexOf('fish') >= 0) return 'balik';
    return TUR_LABEL[s] ? s : 'diger';
  }

  function cinsiyetKey(s) {
    s = String(s || '').toLowerCase();
    if (s.indexOf('erkek') >= 0 || s.indexOf('male') === 0) return 'erkek';
    if (s.indexOf('di') === 0 || s.indexOf('female') >= 0) return 'disi';
    return null;
  }

  function boolVal(v) {
    return v === true || v === 'true' || v === 'Evet' || v === 'evet' || v === 'yes' || v === 'Yes' || v === 1;
  }

  // ---------- Depo ----------
  function readLS() {
    try {
      var p = JSON.parse(localStorage.getItem(LS_KEY));
      return (p && p.petler && p.petler.length !== undefined) ? p : null;
    } catch (e) { return null; }
  }

  var profile = readLS();

  // Rehidrasyon: kalıcı kaynaklarla localStorage'ı birleştir.
  // 1) custom.pet_profili JSON metafield'ı (Flow'un siparişten kopyaladığı site profili)
  // 2) pet_profile metaobject listesi (admin'in yönettiği kayıtlar) — pet bazında bindirilir
  (function rehydrate() {
    var jm = boot.metafieldJson;
    if (jm && jm.petler && jm.petler.length && (!profile || (jm.guncelleme || 0) > (profile.guncelleme || 0))) {
      profile = jm;
    }

    var mf = boot.metafield;
    if (mf && mf.petler && mf.petler.length) {
      var petler = [];
      mf.petler.forEach(function (p) {
        if (!p || !p.ad) return;
        // Kilo alanı ölçü tipiyse {"value":4.2,"unit":...} şeklinde gelir
        var kiloRaw = (p.kilo && typeof p.kilo === 'object') ? p.kilo.value : p.kilo;
        petler.push({
          id: p.handle || p.id,
          handle: p.handle || null,
          ad: p.ad,
          tur: turKey(p.tur),
          irk: p.irk || '',
          dogum: p.dogum || null,
          kilo: num(kiloRaw),
          cinsiyet: cinsiyetKey(p.cinsiyet),
          kisir: boolVal(p.kisir),
          alerji: [].concat(p.alerji || []),
          diyet: p.diyet || null,
          saglik: p.saglik || null,
          mama_markasi: p.mama_markasi || null
        });
      });
      if (petler.length && (!profile || !profile.petler || !profile.petler.length)) {
        profile = { v: 1, guncelleme: mf.guncelleme || 0, petler: petler };
      } else if (petler.length) {
        var moNewer = (mf.guncelleme || 0) > (profile.guncelleme || 0);
        petler.forEach(function (mp) {
          var idx = -1;
          profile.petler.forEach(function (p, i) { if (p.id === mp.id) idx = i; });
          if (idx < 0) profile.petler.push(mp);
          // metaobject'te fotoğraf alanı yok: yerel/metafield profildeki foto korunur
          else if (moNewer) { mp.foto = profile.petler[idx].foto || null; profile.petler[idx] = mp; }
        });
        if (moNewer) profile.guncelleme = mf.guncelleme;
      }
    }

    if (profile) {
      try { localStorage.setItem(LS_KEY, JSON.stringify(profile)); } catch (e) {}
    }
  })();

  function pets() { return (profile && profile.petler) || []; }

  function persist() {
    profile = profile || { v: 1, petler: [] };
    profile.v = 1;
    profile.guncelleme = Date.now();
    try { localStorage.setItem(LS_KEY, JSON.stringify(profile)); } catch (e) {}
    syncCart();
    syncServer();
    renderList();
    renderBadge();
    renderInvite();
    renderSizeQ();
    renderSiklik();
    renderCardBadges();
    renderReorder();
    renderBought();
    // pet-quiz.js gibi dinleyiciler için profil değişim sinyali
    try { document.dispatchEvent(new CustomEvent('petidi:profil')); } catch (e) {}
  }

  // ---------- App proxy köprüsü: profili anında müşteri kartına yaz ----------
  // Shopify, /apps/pet-profil isteklerini imzalayıp worker'a iletir (giriş yapmış
  // müşterinin kimliği imzayla gelir); worker custom.pet_profili metafield'ını günceller.
  // Cevaptaki `club` (12 Eki 2026): Pati Profili açana ücretsiz Club — worker (ahtapot/club.js clubPatiVer) verir.
  // acik = kullanıcı "Ücretsiz katıl"a bastı: her sonuç söylenir; değilse yalnız "açıldı" ve hata söylenir.
  function syncServer(acik) {
    if (!boot.loggedIn) return;
    fetch('/apps/pet-profil/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(profile || { v: 1, guncelleme: Date.now(), petler: [] })
    }).then(function (r) { return r.json(); })
      .then(function (d) { clubSonuc(d && d.club, acik); })
      .catch(function () { if (acik) clubSonuc({ durum: 'hata' }, true); });
  }

  // ---------- Pati Profili ile ücretsiz Petidi Club ----------
  var CP = boot.clubPati || {};
  function clubToast(html, iyi) {
    var t = document.querySelector('[data-club-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'petp__toast';
      t.setAttribute('data-club-toast', '');
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.classList.toggle('petp__toast--iyi', !!iyi);
    t.innerHTML = '<span>' + html + '</span><button type="button" class="petp__toast-x" aria-label="' + _t('kapat', 'Kapat') + '" data-club-toast-x>×</button>';
    t.hidden = false;
    window.clearTimeout(clubToast.z);
    clubToast.z = window.setTimeout(function () { t.hidden = true; }, 10000);
  }
  function trTarih(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    return m ? m[3] + '.' + m[2] + '.' + m[1] : '';
  }
  function clubSonuc(c, acik) {
    if (!CP.acik || !c || !c.durum) return;
    if (c.durum === 'verildi') {
      CP.uye = true;
      clubToast(_t(+CP.puan === 0 ? 'pp_club_acildi_puansiz' : 'pp_club_acildi', +CP.puan === 0 ? '<strong>Petidi Club üyeliğin açıldı!</strong> [ne] siparişlerinde Club hediyeleri seni bekliyor.' : '<strong>Petidi Club üyeliğin açıldı!</strong> [ne] her siparişinde %[puan] Petidi Puan.', {
        ne: c.bitis && c.bitis < '2099' ? _t('pp_tarihine_kadar', '[tarih] tarihine kadar', { tarih: trTarih(c.bitis) }) : _t('pp_bundan_sonra', 'Bundan sonra'),
        puan: esc(CP.puan != null ? CP.puan : 3) }), true);
      // Club sayfası / ürün sayfası üye görünümüne geçsin (etiket Liquid'de okunur)
      if (document.querySelector('[data-club-pati-katil]')) window.setTimeout(function () { window.location.reload(); }, 3000);
    } else if (c.durum === 'zaten') {
      CP.uye = true;
      if (acik) clubToast(_t('pp_zaten_uye', 'Zaten Petidi Club üyesisin[ek].', { ek: c.bitis && c.bitis < '2099' ? _t('pp_tarihine_kadar_p', ' ([tarih] tarihine kadar)', { tarih: trTarih(c.bitis) }) : '' }), true);
    } else if (c.durum === 'hata' || acik) {
      clubToast(_t('pp_club_hata', 'Club üyeliğin şu an açılamadı. Profilin kaydedildi; birkaç dakika sonra <a href="[url]">Club sayfasından</a> tekrar dene, olmazsa bize yaz.', { url: esc(CP.url || (KOK + '/')) }));
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-club-toast-x]')) { var t = document.querySelector('[data-club-toast]'); if (t) t.hidden = true; return; }
    var k = e.target.closest('[data-club-pati-katil]');
    if (!k) return;
    e.preventDefault();
    if (boot.loggedIn && pets().length) {
      // Profili zaten var: kaydı tekrar gönder, worker üyeliği açar (bir kez)
      syncServer(true);
      return;
    }
    // Profili yok (ya da misafir): yeni dost formunu aç; kaydedince üyelik açılır / misafire giriş notu çıkar
    openDrawer();
    if (!pets().length) showForm(null);
  });

  // ---------- Sepet attribute köprüsü ----------
  var lastSynced = boot.cartAttr || '';
  function syncCart() {
    var val = pets().length ? JSON.stringify(profile) : '';
    if (val === lastSynced) return;
    var attrs = {};
    attrs[ATTR_KEY] = val;
    fetch(KOK + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (r.ok) lastSynced = val; }).catch(function () {});
  }

  // ---------- Yaş & porsiyon ----------
  function ageMonths(dogum) {
    if (!dogum) return null;
    var m = /^(\d{4})(?:-(\d{1,2}))?/.exec(String(dogum));
    if (!m) return null;
    var now = new Date();
    var months = (now.getFullYear() - +m[1]) * 12 + (now.getMonth() + 1 - (+m[2] || 6));
    return months < 0 ? 0 : months;
  }

  function ageLabel(dogum) {
    var ay = ageMonths(dogum);
    if (ay === null) return '';
    if (ay < 12) return _tn('pp_aylik', ay, '[n] aylık');
    return _tn('pp_yas', Math.floor(ay / 12), '[n] yaş');
  }

  // Ürüne özel besleme tablosu (custom.besleme_tablosu, paketin arkasındaki tablo — 14 Eki 2026):
  // "2=25, 3=40, 4=55, 5=65, 6=80, +15" → hayvan kilosu=gr/gün; "+15" son satırdan sonra kilo başına ek gr.
  // Ondalık virgül olabilir ("1,5=20"); gramdaki virgül ancak ardından "=" gelmiyorsa ondalıktır ("140,20=230" → 140 ve 20=230).
  // Hatırlatma worker'ında (worker dalı hatirlatma/porsiyon.js beslemeAyristir/tablodanGram) AYNI kural — ikisini birlikte değiştir.
  function parseBesleme(str) {
    if (!str) return null;
    var cift = /(\d+(?:[.,]\d+)?)\s*=\s*(\d+(?:[.,]\d+(?![\d.,]*\s*=))?)/g, m, pts = [];
    while ((m = cift.exec(str))) pts.push([parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))]);
    if (!pts.length) return null;
    pts.sort(function (a, b) { return a[0] - b[0]; });
    var ek = /\+\s*(\d+(?:[.,]\d+)?)/.exec(String(str).replace(cift, ''));
    return { p: pts, ek: ek ? parseFloat(ek[1].replace(',', '.')) : null };
  }

  // Tablodan gr/gün: aradaki kilolar doğrusal; en küçükten hafif hayvana kg^0.75 oranıyla; en büyükten sonra "+ek"
  // (yoksa son aralığın eğimi). Tablo hayvanın durumunu (kısır vb.) zaten içerdiği için çarpan uygulanmaz.
  function tablodanGram(t, kg) {
    var p = t.p, n = p.length;
    if (kg <= p[0][0]) return p[0][1] * Math.pow(kg / p[0][0], 0.75);
    if (kg >= p[n - 1][0]) {
      var egim = t.ek != null ? t.ek : (n > 1 ? (p[n - 1][1] - p[n - 2][1]) / (p[n - 1][0] - p[n - 2][0]) : p[n - 1][1] / p[n - 1][0]);
      return p[n - 1][1] + egim * (kg - p[n - 1][0]);
    }
    for (var i = 1; i < n; i++) {
      if (kg <= p[i][0]) return p[i - 1][1] + (p[i][1] - p[i - 1][1]) * (kg - p[i - 1][0]) / (p[i][0] - p[i - 1][0]);
    }
    return p[n - 1][1];
  }

  // Genel tüketim eğrisi (kuru mama, gr/gün): enerji ihtiyacı ~ kg^0.75. Ürünün besleme tablosu varsa o kazanır.
  function dailyGrams(pet, besleme) {
    var kg = num(pet.kilo);
    if (!kg) return 0;
    var t = typeof besleme === 'string' ? parseBesleme(besleme) : besleme;
    if (t && (pet.tur === 'kedi' || pet.tur === 'kopek')) return tablodanGram(t, kg);
    var base;
    if (pet.tur === 'kedi') base = 18 * Math.pow(kg, 0.75);
    else if (pet.tur === 'kopek') base = 26.5 * Math.pow(kg, 0.75);
    else return 0;
    var ay = ageMonths(pet.dogum);
    if (ay !== null) {
      if (ay < 12) base *= 1.5;
      else if (ay >= (pet.tur === 'kedi' ? 120 : 96)) base *= 0.9;
    }
    if (pet.kisir) base *= 0.9;
    return base;
  }

  // ---------- Türün toplam tüketimi (17 Eki 2026, kullanıcı kararı) ----------
  // Çok dostlu evde ürünün türündeki (kedi/köpek) TÜM dostların günlük gramı toplanır; "kaç gün yeter" rozeti, "hangi boy?"
  // şeridi, kart rozetleri ve abonelikte önerilen sıklık AYNI toplamı ve AYNI gün yazımını (gunEtiket) kullanır — ekranda iki
  // farklı gün sayısı çıkmasın. Kilosu girilmemiş dost ortalama varsayımla (kedi 4, köpek 20 kg); hiçbirinin kilosu yoksa
  // { kilo:false, pet }. Dönüş: null (o türde dost yok) | { kilo:false, pet } | { list, daily, ad, tek }
  var TUR_IYELIK = { kedi: _t('pp_kedin', 'kedin'), kopek: _t('pp_kopegin', 'köpeğin') };
  function adListe(list) {
    var adlar = list.map(function (p) { return p.ad; });
    if (adlar.length > 3) return adlar.length + ' ' + (TUR_IYELIK[list[0].tur] || _t('pp_dostun', 'dostun'));
    if (adlar.length === 1) return adlar[0];
    return adlar.slice(0, -1).join(', ') + ' ' + _t('ve', 've') + ' ' + adlar[adlar.length - 1];
  }
  // Saf çekirdek (DOM'suz): türün toplam gr/günü. Hatırlatma worker'ında (worker dalı hatirlatma/porsiyon.js turGunluk) AYNI
  // hesap — Tekrar Al'ın bitiş tahmini ile WhatsApp "maman bitiyor" zamanı aynı sayıyı versin. Birlikte değiştir
  // (tests/hatirlatma/porsiyon.test.mjs bu dosyadaki num/ageMonths/parseBesleme/tablodanGram/dailyGrams/turGunluk'u
  // worker'la aynı örneklerde koşturur). Dönüş: null | { list, daily, kilolu } (kilolu: kilosu girilmiş dost sayısı).
  function turGunluk(petList, species, besleme) {
    if (!species) return null;
    var list = (petList || []).filter(function (p) { return p && p.tur === species; });
    if (!list.length) return null;
    var t = typeof besleme === 'string' ? parseBesleme(besleme) : besleme;
    var ort = species === 'kedi' ? 4 : 20, daily = 0, kilolu = 0;
    list.forEach(function (p) {
      var g = dailyGrams(p, t);
      if (g) kilolu++;
      else g = dailyGrams({ tur: p.tur, kilo: ort, dogum: p.dogum, kisir: p.kisir }, t);
      daily += g;
    });
    if (!(daily > 0)) return null;
    return { list: list, daily: daily, kilolu: kilolu };
  }
  function turToplam(species, besleme) {
    var tg = turGunluk(pets(), species, besleme);
    if (!tg) return null;
    if (!tg.kilolu) return { kilo: false, pet: tg.list[0] };
    return { list: tg.list, daily: tg.daily, ad: adListe(tg.list), tek: tg.list.length === 1 };
  }
  function gunEtiket(gun) {
    var d = Math.round(gun);
    var n = d >= 10 ? Math.round(d / 5) * 5 : Math.max(1, d);
    return d > 120 ? _t('pp_120_gun', '120+ gün') : _tn('pp_yak_gun', n, '~[n] gün');
  }

  // ---------- Ürün sayfası rozeti ----------
  function selectedVariantKg(el) {
    var sel = document.querySelector('.pd__variant.is-selected');
    var kg = sel ? parseFloat(sel.getAttribute('data-kg')) : 0;
    if (!kg || kg <= 0) kg = parseFloat(el.getAttribute('data-kg')) || 0;
    return kg;
  }

  function renderBadge() {
    var el = document.querySelector('[data-pet-days]');
    if (!el) return;
    var species = el.getAttribute('data-species');
    var kg = selectedVariantKg(el);
    if (!kg) { el.hidden = true; return; }

    var tt = turToplam(species, el.getAttribute('data-besleme'));

    el.hidden = false;
    if (!tt) {
      // Merak boşluğu: ortalama bir hayvan için gerçek tahmini hesapla, bulanık göster
      var avgLabel = daysLabel(kg, { tur: species, kilo: species === 'kedi' ? 4 : 20 }, el.getAttribute('data-besleme'));
      el.innerHTML = '<span class="pd__petdays-cta">' + _t('pp_paket_yeter', 'Bu paket dostuna <span class="pd__petdays-blur">[gun]</span> yeter', { gun: avgLabel }) + '</span>' +
        '<button type="button" class="pd__petdays-btn" data-petp-open>' + _t('pp_ogren', 'Öğren') + '</button>';
      el.classList.add('pd__petdays--pulse');
      return;
    }
    el.classList.remove('pd__petdays--pulse');
    if (tt.kilo === false) {
      el.innerHTML = '<span class="pd__petdays-cta">' + _t('pp_kac_gun', '[ad] için kaç gün?', { ad: esc(tt.pet.ad) }) + '</span>' +
        '<button type="button" class="pd__petdays-btn" data-petp-open data-petp-edit="' + esc(tt.pet.id) + '">' + _t('pp_kilosunu_ekle', 'Kilosunu ekle') + '</button>';
      return;
    }
    var label = gunEtiket(kg * 1000 / tt.daily);
    var kgLabel = String(kg).replace('.', _t('ondalik', ',')) + ' kg';
    el.innerHTML = '<span class="pd__petdays-cta">' + _t('pp_paket_icin', '<strong>[kg]</strong> paket <strong>[ad]</strong> için yaklaşık <strong>[gun]</strong> yeter', { kg: kgLabel, ad: esc(tt.ad), gun: label }) + '</span>';
  }

  // ---------- Davet kartları: profil yoksa görünür (ürün sayfası + sepet) ----------
  function renderInvite() {
    var els = document.querySelectorAll('[data-pet-invite]');
    if (!els.length) return;
    var hide = pets().length > 0;
    Array.prototype.forEach.call(els, function (el) { el.hidden = hide; });
  }

  // ---------- "Hangi boy?" şeridi ----------
  function renderSizeQ() {
    var el = document.querySelector('[data-pet-sizeq]');
    if (!el) return;
    var tt = turToplam(el.getAttribute('data-species'), el.getAttribute('data-besleme'));

    // Profil yokken hemen alttaki davet kartı (data-pet-invite) aynı çağrıyı
    // zaten yapıyor — şeridi hiç gösterme, tekrar olmasın.
    if (!tt) { el.hidden = true; return; }
    if (tt.kilo === false) {
      // Profil var ama kilo yok (örn. quiz'de "Bilmiyorum") — davet yerine kiloyu iste
      var kp = tt.pet;
      el.innerHTML = '<span class="pd__sizeq-text">' + _t('pp_hangi_boy', '<strong>Hangi boyu almalısın?</strong> [ad]\'in kilosunu ekle, doğru paketi söyleyelim.', { ad: esc(kp.ad) }) + '</span>' +
        '<button type="button" class="pd__petdays-btn" data-petp-open data-petp-edit="' + esc(kp.id) + '">' + _t('pp_kilosunu_ekle', 'Kilosunu ekle') + '</button>';
      el.classList.remove('pd__sizeq--reco');
      el.hidden = false;
      return;
    }
    var daily = tt.daily;

    // Stoktaki, gramajı bilinen varyantlar arasından öneri seç:
    // 100 güne kadar tükenebilecekler içinde kg fiyatı en düşük olan;
    // hiçbiri sığmıyorsa (küçük hayvan) en küçük paket.
    var vars = [];
    document.querySelectorAll('.pd__variant').forEach(function (btn) {
      var vkg = parseFloat(btn.getAttribute('data-kg'));
      var cents = parseFloat(btn.getAttribute('data-pricecents'));
      if (btn.getAttribute('data-available') === '1' && vkg > 0 && cents > 0) {
        vars.push({ kg: vkg, unit: cents / vkg, days: vkg * 1000 / daily });
      }
    });
    if (vars.length < 2) { el.hidden = true; return; }

    var eligible = vars.filter(function (v) { return Math.round(v.days) <= 100; });
    var pick = (eligible.length ? eligible : vars).reduce(function (a, b) {
      if (eligible.length) return b.unit < a.unit ? b : a;
      return b.days < a.days ? b : a;
    });
    var worstUnit = 0;
    vars.forEach(function (v) { if (v.unit > worstUnit) worstUnit = v.unit; });
    var adv = worstUnit > 0 ? Math.round((1 - pick.unit / worstUnit) * 100) : 0;

    var dLbl = gunEtiket;
    function kgLbl(kg) { return String(kg).replace('.', _t('ondalik', ',')) + ' kg'; }
    var gDaily = Math.max(5, Math.round(daily / 5) * 5);
    // Tek dost: eski yazılar ("Minnoş günde ~45 gr yiyor"). Çok dost (17 Eki 2026): "Minnoş, Pamuk ve Tarçın için doğru boy:
    // 10 kg — günde ~145 gr, bu paket ~70 gün gider" (4+ dostta "4 kedin").
    var ad = esc(tt.ad), tek = tt.tek;
    var kime = tek ? _t('pp_kime_tek', '[ad]\'a', { ad: ad }) : _t('pp_kime', '[ad] için', { ad: ad });

    // Seçili varyanta göre mesaj: onay / tazelik uyarısı / ipucu
    var sel = document.querySelector('.pd__variant.is-selected');
    var selKg = sel ? parseFloat(sel.getAttribute('data-kg')) : 0;
    var selCents = sel ? parseFloat(sel.getAttribute('data-pricecents')) : 0;
    var avantaj = adv >= 5 ? _t('pp_avantaj', ' Kg fiyatı da %[n] daha düşük.', { n: adv }) : '';
    var msg;
    if (selKg > 0 && Math.abs(selKg - pick.kg) < 0.01) {
      msg = tek
        ? _t('pp_dogru_tek', '<strong>Doğru boy: [kg].</strong> [ad] günde yaklaşık [g] gr yer; bu paket ona [gun] yeter.[av]', { kg: kgLbl(pick.kg), ad: ad, g: gDaily, gun: dLbl(pick.days), av: avantaj })
        : _t('pp_dogru_cok', '<strong>[ad] için doğru boy: [kg].</strong> Günde toplam yaklaşık [g] gr yerler; bu paket [gun] yeter.[av]', { kg: kgLbl(pick.kg), ad: ad, g: gDaily, gun: dLbl(pick.days), av: avantaj });
    } else if (selKg > 0) {
      var selDays = selKg * 1000 / daily;
      var selUnit = selCents > 0 ? selCents / selKg : 0;
      var advSel = (selUnit > 0 && pick.unit < selUnit) ? Math.round((1 - pick.unit / selUnit) * 100) : 0;
      if (Math.round(selDays) > 120) {
        msg = _t('pp_tazelik', 'Seçili <strong>[kg]</strong> paket [kime] [gun] yeter; açılan kuru mama bu sürede tazeliğini yitirebilir. <strong>Önerimiz: [okg]</strong> ([ogun] yeter).', { kg: kgLbl(selKg), kime: kime, gun: dLbl(selDays), okg: kgLbl(pick.kg), ogun: dLbl(pick.days) });
      } else if (advSel >= 5) {
        msg = _t('pp_ipucu', 'Seçili <strong>[kg]</strong> paket [kime][gun] yeter. <strong>İpucu:</strong> [okg] boyda kg fiyatı %[n] daha düşük ([ogun] yeter).', { kg: kgLbl(selKg), kime: tek ? '' : _t('pp_kime_bos', '[ad] için ', { ad: ad }), gun: dLbl(selDays), okg: kgLbl(pick.kg), n: advSel, ogun: dLbl(pick.days) });
      } else {
        msg = _t('pp_uygun', '<strong>[kg]</strong> paket [ad] için uygun: günde yaklaşık [g] gr ile [gun] yeter.', { kg: kgLbl(selKg), ad: ad, g: gDaily, gun: dLbl(selDays) });
      }
    } else {
      msg = tek
        ? _t('pp_oneri_tek', '<strong>[ad] için önerimiz: [kg].</strong> Günde yaklaşık [g] gr yer; bu paket ona [gun] yeter.[av]', { ad: ad, kg: kgLbl(pick.kg), g: gDaily, gun: dLbl(pick.days), av: avantaj })
        : _t('pp_oneri_cok', '<strong>[ad] için önerimiz: [kg].</strong> Günde toplam yaklaşık [g] gr yerler; bu paket [gun] yeter.[av]', { ad: ad, kg: kgLbl(pick.kg), g: gDaily, gun: dLbl(pick.days), av: avantaj });
    }
    el.innerHTML = '<span class="pd__sizeq-text">' + msg + '</span>';
    el.classList.add('pd__sizeq--reco');
    el.hidden = false;
  }

  // ---------- Abonelikte önerilen sıklık (17 Eki 2026, kullanıcı kararı; tema ayarı abone_siklik_oneri) ----------
  // Paket kaç gün gider = kg × 1000 ÷ (ürünün türündeki TÜM dostların günlük gramı, dailyGrams — porsiyon eğrisi ya da
  // ürünün besleme tablosu). Seçenekler 1–16 hafta: gittiği günden kısa EN BÜYÜK hafta (yeni paket bitmeden gelsin);
  // bir haftadan kısa gidiyorsa 1 hafta + not. Kilosu girilmemiş dost ortalama varsayımla (kedi 4, köpek 20 kg) sayılır;
  // o türde hiçbir dostun kilosu yoksa öneri yok. Kaynak: Pati Profili (girişliyse metafield'la birleşmiş hâli, misafirse yerel).
  // Dönüş: null (o türde dost yok) | { kilo:false, pet } | { hafta, gun, gram, metin }
  // sinir: teslimat sıklığına üst sınır (haftaSiniri, 21 Eki 2026) — önerilen onu aşamaz; verilmezse 16.
  function siklikOneri(species, kg, besleme, sinir) {
    kg = parseFloat(kg);
    if (!(kg > 0)) return null;
    var tt = turToplam(species, besleme);
    if (!tt || tt.kilo === false) return tt;
    var gun = kg * 1000 / tt.daily;
    var hafta = Math.max(1, Math.min(sinir > 0 ? sinir : 16, 16, Math.floor(gun / 7)));
    var gram = Math.max(5, Math.round(tt.daily / 5) * 5);
    var metin = _t('pp_siklik_metin', '<strong>Önerilen: [h].</strong> [ad] günde yaklaşık [g] gr yer; bu paket [gun] yeter.', { h: _tn('pp_haftada', hafta, '[n] haftada bir'), ad: esc(tt.ad), g: gram, gun: gunEtiket(gun) });
    if (gun < 7) metin += _t('pp_buyuk_boy', ' Daha büyük boy daha uygun olabilir.');
    return { hafta: hafta, gun: gun, gram: gram, metin: metin };
  }

  // ---------- Teslimat sıklığına üst sınır (kullanıcı kararı, 21 Eki 2026; docs/abonelik.md "Teslimat sıklığına üst sınır") ----------
  // En uzun hafta = floor(paket gramı × adet ÷ o mamaya uygun EN HAFİF tek hayvanın gr/günü ÷ 7) + 1 hafta pay, 1–16'ya kırpılır
  // (adetle çarpım: kullanıcı kararı 26 Eki — 2 × 10 kg Maxi → 10 hafta).
  // En hafif = en az yiyen = paket en UZUN gider → sınır cömert taraftadır (küçük hayvanı olan müşteri de sığar).
  // Ağırlık [Claude önerisi]: kedi 3 kg; köpek mamanın boyuna göre Mini/Small 3, Medium 10, Maxi/Large/Giant 25 kg (boy yazmıyorsa 3).
  // Günlük gram: ürünün besleme tablosu, yoksa porsiyon formülü (çarpansız). Paket gramı varyant adından ("10 KG", "1.5 KG", "400 GR"),
  // yoksa ürün adından. Yalnız KURU mamada (Liquid data-hafta-sinir'i yalnız kuruda basar); gramı çıkmayan üründe sınır yok (16).
  // Worker'da (worker dalı ahtapot/hafta-siniri.js) AYNI kural — sunucu /apps/yorum/duzenli-kod, sipariş kaydı ve sıklık
  // değiştirmede uygular. tests/ahtapot/hafta-siniri.test.mjs bu dosyadaki paketGrami/enHafifKg/haftaSiniri'yi worker'la
  // aynı örneklerde koşturur — birini değiştirirsen ötekini de değiştir.
  function paketGrami(s) {
    var m = /(\d+(?:[.,]\d+)?)\s*(kg|gr|g)(?![a-zçğıöşü])/i.exec(String(s || ''));
    if (!m) return 0;
    var n = parseFloat(m[1].replace(',', '.'));
    return n > 0 ? (/^k/i.test(m[2]) ? n * 1000 : n) : 0;
  }
  function enHafifKg(tur, ad) {
    if (tur === 'kedi') return 3;
    if (tur !== 'kopek') return 0;
    var s = String(ad || '');
    if (/x-?small|mini|small|toy|küçük\s*[ıiIİ]rk|kucuk\s*[ıiIİ]rk/i.test(s)) return 3;
    if (/medium|orta\s*(ve\s*b[üu]y[üu]k\s*)?[ıiIİ]rk/i.test(s)) return 10;
    if (/maxi|large|giant|büyük\s*[ıiIİ]rk|buyuk\s*[ıiIİ]rk|dev\s*[ıiIİ]rk/i.test(s)) return 25;
    return 3;
  }
  // tur: 'kedi'|'kopek'; gram: paket gramı; besleme: tablo metni; ad: ürün adı (+ tipi) — boy (Mini/Medium/Maxi) buradan;
  // adet: paket adedi (yoksa 1)
  function haftaSiniri(tur, gram, besleme, ad, adet) {
    var kg = enHafifKg(tur, ad);
    var n = Math.max(1, Math.floor(Number(adet)) || 1);
    if (!kg || !(gram > 0)) return 16;
    gram = gram * n;
    var t = typeof besleme === 'string' ? parseBesleme(besleme) : besleme;
    var g = t ? tablodanGram(t, kg) : (tur === 'kedi' ? 18 : 26.5) * Math.pow(kg, 0.75);
    if (!(g > 0)) return 16;
    return Math.max(1, Math.min(16, Math.floor(gram / g / 7) + 1));
  }
  // [data-hafta-sinir] kabının sınırı: ürün sayfasında seçili boyun adı (.pd__variant data-boy), yoksa data-hs-paket
  // (ürün sayfasında ürün adı; sepette varyant + ürün adı). data-hs-tur, data-hs-ad (ürün adı + tipi), data-besleme.
  function kapSiniri(kap) {
    if (!kap || !kap.hasAttribute('data-hafta-sinir')) return 16;
    var boy = '', adet = kap.getAttribute('data-hs-adet');
    if (!kap.classList.contains('cart__abone')) {
      var v = document.querySelector('.pd__variant.is-selected[data-variant-id]');
      if (v) boy = v.getAttribute('data-boy') || '';
      var q = document.querySelector('[data-qty-input]');
      adet = q ? q.value : 1;
    }
    var gram = paketGrami(boy) || paketGrami(kap.getAttribute('data-hs-paket'));
    return haftaSiniri(kap.getAttribute('data-hs-tur'), gram, kap.getAttribute('data-besleme'), kap.getAttribute('data-hs-ad'), adet);
  }
  // Select'te yalnız 1..sınır kalır (iOS gizli option'ı gösterdiği için silinir; boy değişince ilk kopyadan yeniden kurulur).
  // Seçili hafta sınırı aşıyorsa sınıra çekilir. Sepette satırın kayıtlı haftası aşıyorsa select sınırı gösterir; sunucu
  // (duzenli-kod + sipariş kaydı) da kırpar.
  function renderHaftaSiniri() {
    document.querySelectorAll('[data-hafta-sinir]').forEach(function (kap) {
      var sel = kap.querySelector('select');
      if (!sel) return;
      var max = kapSiniri(kap);
      if (!sel._tum) sel._tum = Array.prototype.map.call(sel.options, function (o) { return o.cloneNode(true); });
      var v = parseInt(sel.value, 10) || 0;
      if (+sel.getAttribute('data-sinir') === max) return;
      sel.setAttribute('data-sinir', String(max));
      while (sel.firstChild) sel.removeChild(sel.firstChild);
      sel._tum.forEach(function (o) { if ((parseInt(o.value, 10) || 0) <= max) sel.appendChild(o.cloneNode(true)); });
      sel.value = String(Math.min(v || 4, max));
    });
  }

  // Ürün sayfası (club-secim [data-siklik] + select[data-duzenli-hafta]) ve sepet (.cart__abone[data-siklik]).
  // Ürün sayfasında select'i önerilene çeker — müşteri elle değiştirdiyse (data-elle) asla. Sepette yalnız sebep satırı;
  // satırın kayıtlı sıklığına dokunulmaz (cart.js kutucuk işaretlenince siklikOneri'den alır).
  function renderSiklik() {
    renderHaftaSiniri();
    document.querySelectorAll('[data-siklik]').forEach(function (kap) {
      var urunde = !kap.classList.contains('cart__abone');
      var kg = urunde ? selectedVariantKg(kap) : parseFloat(kap.getAttribute('data-kg'));
      var o = siklikOneri(kap.getAttribute('data-species'), kg, kap.getAttribute('data-besleme'), kapSiniri(kap));
      var satir = urunde ? (kap.parentNode && kap.parentNode.querySelector('[data-siklik-oneri]')) : kap.querySelector('[data-siklik-oneri]');
      var sel = kap.querySelector('select');
      if (o && o.hafta && sel && urunde && sel.getAttribute('data-elle') !== '1') {
        sel.value = String(o.hafta);
        sel.setAttribute('data-oneri', String(o.hafta));
      }
      if (!satir) return;
      if (o && o.hafta) { satir.innerHTML = o.metin; satir.hidden = false; }
      else if (o && o.kilo === false) {
        satir.innerHTML = '<button type="button" class="pk__nekadar" data-petp-open data-petp-edit="' + esc(o.pet.id) + '">' +
          _t('pp_siklik_kilo', '[ad]\'in kilosunu ekle, sana uygun sıklığı önerelim', { ad: esc(o.pet.ad) }) + '</button>';
        satir.hidden = false;
      } else { satir.innerHTML = ''; satir.hidden = true; }
    });
  }
  // Ürün sayfasında adet değişince sınır yeniden (26 Eki: adetle çarpım). product.js −/+ ve paket düğmeleri değeri programla
  // atar (change üretmez) → tıklamadan sonra da yeniden kurulur.
  document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('[data-qty-input]')) renderHaftaSiniri(); });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-qty-minus], [data-qty-plus], [data-paket]')) window.setTimeout(renderHaftaSiniri, 0);
  });
  // Elle seçim: renderSiklik value'yu programla atar (change olayı üretmez) → her change olayı müşterinin seçimidir
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (s && s.matches && s.matches('[data-siklik] select[data-duzenli-hafta]')) s.setAttribute('data-elle', '1');
  });

  // ---------- "Tekrar Al": son mama alımı + zamanlama ----------
  // Veri: #PetReorderData (pet-profile.liquid, customer.orders'tan tür başına
  // en yeni kuru mama). Zamanlama porsiyon eğrisinden; %20 eşiği hatırlatma
  // worker'ıyla aynı.
  var REORDER_LS = 'petidi_tekrar_kapat';
  var reorderData = [];
  try {
    var rEl = document.getElementById('PetReorderData');
    if (rEl) reorderData = JSON.parse(rEl.textContent).alimlar || [];
  } catch (e) {}

  function purchaseFor(species) {
    for (var i = 0; i < reorderData.length; i++) {
      if (reorderData[i].sp === species) return reorderData[i];
    }
    return null;
  }

  // Çok dostlu ev (17 Eki 2026): bitiş tahmini de türün TÜM dostlarının toplamıyla (turGunluk — "kaç gün yeter" rozeti ve
  // hatırlatma worker'ıyla aynı sayı). Gün = paket kg × adet × 1000 ÷ toplam gr/gün. Kilosu girilmemiş dost ortalama
  // varsayımla (hatırlatma da öyle). O türde dost yoksa tahmin yok (pet: null).
  function reorderInfo(item) {
    var tg = turGunluk(pets(), item.sp, item.b);
    var pet = tg ? tg.list[0] : null;
    var ad = tg ? adListe(tg.list) : '';
    var kgTop = (item.kg || 0) * (item.q > 0 ? item.q : 1);
    var toplam = (kgTop > 0 && tg && tg.daily > 0) ? Math.round(kgTop * 1000 / tg.daily) : 0;
    var gecen = Math.floor((Date.now() - item.ts) / 86400000);
    var kalan = toplam ? toplam - gecen : null;
    var mode = null;
    if (toplam) {
      if (kalan <= 0) mode = 'out';
      else if (kalan <= toplam * 0.2) mode = 'soon';
      else mode = 'early';
    }
    return { pet: pet, ad: ad, toplam: toplam, gecen: gecen, kalan: kalan, mode: mode };
  }

  function trDate(ts) {
    var opts = { day: 'numeric', month: 'long' };
    if (Date.now() - ts > 300 * 86400000) opts.year = 'numeric';
    try { return new Date(ts).toLocaleDateString(_t('yerel', 'tr-TR'), opts); } catch (e) { return new Date(ts).toLocaleDateString(); }
  }

  function tlPrice(cents) {
    var v = cents / 100;
    return v.toLocaleString('tr-TR', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: v % 1 ? 2 : 0 }) + ' TL';
  }

  function reorderBtn(item, cls) {
    if (item.av === 1 && item.vid) {
      return '<button type="button" class="' + cls + '" data-reorder-add="' + item.vid + '">' + _t('tekrar_al', 'Tekrar Al') +
        (cls === 'reorder__btn' && item.f ? ' · ' + tlPrice(item.f) : '') + '</button>';
    }
    return item.u ? '<a class="' + cls + '" href="' + esc(item.u) + '">' + _t('urune_git', 'Ürüne Git') + '</a>' : '';
  }

  // Ana sayfa + koleksiyon şeridi (bitmek üzere / bitti durumunda)
  function renderReorder() {
    var el = document.querySelector('[data-pet-reorder]');
    if (!el) return;
    var tpl = el.getAttribute('data-template') || '';
    if (tpl !== 'index' && tpl !== 'collection') { el.hidden = true; return; }

    var show = null, info = null;
    for (var i = 0; i < reorderData.length; i++) {
      var it = reorderData[i];
      var key = it.vid + ':' + it.ts;
      try { if (localStorage.getItem(REORDER_LS) === key) continue; } catch (e) {}
      var inf = reorderInfo(it);
      if (inf.pet && (inf.mode === 'soon' || inf.mode === 'out')) { show = it; info = inf; break; }
    }
    if (!show) {
      el.hidden = true; el.innerHTML = ''; el.style.minHeight = '';
      try { localStorage.removeItem('petidi_tekrar_h'); } catch (e) {}
      return;
    }

    var soon = info.mode === 'soon';
    var head = soon
      ? _tn('pp_bitmek_uzere', info.kalan, '<strong>[ad]</strong> için aldığın mama bitmek üzere — ~[n] gün kaldı', { ad: esc(info.ad) })
      : _t('pp_bitmis', '<strong>[ad]</strong> için aldığın mama bitmiş olmalı', { ad: esc(info.ad) });
    var sub = esc(show.t) + (show.vt ? ' · ' + esc(show.vt) : '') + ' · ' + _t('pp_tarihinde', '[tarih] tarihinde almıştın', { tarih: trDate(show.ts) });
    el.setAttribute('data-reorder-key', show.vid + ':' + show.ts);
    el.innerHTML = '<div class="reorder ' + (soon ? 'reorder--soon' : 'reorder--out') + '">' +
      '<span class="reorder__img">' + (show.img ? '<img src="' + esc(show.img) + '" alt="" loading="lazy" width="46" height="46">' : (IK.paw || '')) + '</span>' +
      '<span class="reorder__body"><span class="reorder__head">' + head + '</span>' +
      '<span class="reorder__sub">' + sub + '</span></span>' +
      reorderBtn(show, 'reorder__btn') +
      '<button type="button" class="reorder__x" data-reorder-close aria-label="' + _t('kapat', 'Kapat') + '">✕</button>' +
      '</div>';
    el.hidden = false;
    // CLS önlemi: gerçek yüksekliği kaydet — sonraki sayfa yüklemesinde
    // theme.liquid'deki inline script bu kadar yer ayırır.
    try {
      el.style.minHeight = '';
      localStorage.setItem('petidi_tekrar_h', el.offsetHeight);
    } catch (e) {}
  }

  // Ürün sayfası: "bunu daha önce almıştın" notu
  function renderBought() {
    var el = document.querySelector('[data-pet-bought]');
    if (!el) return;
    var h = el.getAttribute('data-handle');
    var item = null;
    for (var i = 0; i < reorderData.length; i++) {
      if (reorderData[i].h && reorderData[i].h === h) { item = reorderData[i]; break; }
    }
    if (!item) { el.hidden = true; return; }
    var info = reorderInfo(item);
    var ek = '';
    if (info.mode === 'out') ek = _t('pp_ek_bitmis', ' — bitmiş olmalı');
    else if (info.mode === 'soon') ek = _tn('pp_ek_bitmesine', info.kalan, ' — bitmesine ~[n] gün var');
    var txt = el.querySelector('[data-pet-bought-txt]') || el;
    txt.innerHTML = (info.pet
      ? _t('pp_bunu_icin', 'Bunu <strong>[ad]</strong> için <strong>[tarih]</strong> tarihinde almıştın[ek].', { ad: esc(info.ad), tarih: trDate(item.ts), ek: ek })
      : _t('pp_bunu', 'Bunu <strong>[tarih]</strong> tarihinde almıştın[ek].', { tarih: trDate(item.ts), ek: ek }));
    el.hidden = false;
  }

  // ---------- Ürün kartı rozetleri (koleksiyon/karusel) ----------
  function daysLabel(kg, pet, besleme) {
    var daily = dailyGrams(pet, besleme);
    if (!kg || !daily) return '';
    return gunEtiket(kg * 1000 / daily);
  }

  function renderCardBadges(scope) {
    var root = scope || document;
    var found = root.querySelectorAll('[data-pet-days-card]');
    var nodes = found;
    // Kapsam düğümün kendisi rozet ise onu da dahil et (querySelectorAll kökü katmaz)
    if (scope && scope.matches && scope.matches('[data-pet-days-card]')) {
      nodes = [scope];
      for (var f = 0; f < found.length; f++) nodes.push(found[f]);
    }
    if (!nodes.length) return;
    Array.prototype.forEach.call(nodes, function (el) {
      var species = el.getAttribute('data-species');
      // Kartta seçili varyant varsa onun gramajını, yoksa snippet'in verdiğini kullan
      var kg = 0;
      var cardEl = el.closest('.pcard');
      var sel = cardEl && cardEl.querySelector('[data-card-variant].is-selected');
      if (sel) kg = parseFloat(sel.getAttribute('data-kg')) || 0;
      if (!kg) kg = parseFloat(el.getAttribute('data-kg')) || 0;
      // Türün tüm dostlarının toplamı (17 Eki 2026) — ürün sayfasındaki rozet/şeritle aynı gün sayısı
      var tt = turToplam(species, el.getAttribute('data-besleme'));
      var label = (kg && tt && tt.daily) ? gunEtiket(kg * 1000 / tt.daily) : '';
      if (!label) { el.hidden = true; el.textContent = ''; return; }
      el.textContent = _t('pp_yeter', '[gun] yeter', { gun: label });
      el.hidden = false;
    });
  }

  // Sonsuz kaydırma / dinamik eklenen kartlar için.
  // Yeni eklenen düğümleri biriktirip bir sonraki frame'de TEK sefer işleriz.
  // (Eskiden her eklenen kart için tüm ızgara baştan taranıyordu → karesel
  //  uzun görev, dokunuşu geciktirip INP'yi bozuyordu; misafirde bile.)
  var pendingCards = [];
  var badgeRaf = 0;
  function flushCardBadges() {
    badgeRaf = 0;
    var nodes = pendingCards;
    pendingCards = [];
    if (!pets().length) return; // misafir/profilsiz: rozet yok, işi tümden atla
    for (var i = 0; i < nodes.length; i++) renderCardBadges(nodes[i]);
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('[data-pet-days-card]')) || (n.querySelector && n.querySelector('[data-pet-days-card]'))) {
          pendingCards.push(n); // sadece bu düğümün içi işlenir, tüm ızgara değil
        }
      }
    }
    if (pendingCards.length && !badgeRaf) badgeRaf = window.requestAnimationFrame(flushCardBadges);
  }).observe(document.body, { childList: true, subtree: true });

  // ---------- Çekmece ----------
  var listView = root.querySelector('[data-petp-view-list]');
  var formView = root.querySelector('[data-petp-view-form]');
  var listEl = root.querySelector('[data-petp-list]');
  var titleEl = root.querySelector('[data-petp-title]');
  var guestNote = root.querySelector('[data-petp-guest-note]');

  var fId = root.querySelector('[data-petp-f-id]');
  var fAd = root.querySelector('[data-petp-f-ad]');
  var fTur = root.querySelector('[data-petp-f-tur]');
  var fIrk = root.querySelector('[data-petp-f-irk]');
  var fYil = root.querySelector('[data-petp-f-yil]');
  var fAy = root.querySelector('[data-petp-f-ay]');
  var fKilo = root.querySelector('[data-petp-f-kilo]');
  var fKiloHata = root.querySelector('[data-petp-kilo-hata]');
  function kiloHataGoster(m) { if (!fKiloHata) return; fKiloHata.textContent = m || ''; fKiloHata.hidden = !m; if (fKilo) fKilo.setAttribute('aria-invalid', m ? 'true' : 'false'); }
  if (fKilo) fKilo.addEventListener('input', function () { kiloHataGoster(''); });
  var fCinsiyet = root.querySelector('[data-petp-f-cinsiyet]');
  var fKisir = root.querySelector('[data-petp-f-kisir]');
  var fAlerji = root.querySelector('[data-petp-f-alerji]');
  var fDelete = root.querySelector('[data-petp-delete]');
  var fFotoAv = root.querySelector('[data-petp-foto-av]');
  var fFotoIn = root.querySelector('[data-petp-foto-input]');
  var fFotoBtn = root.querySelector('[data-petp-foto-btn]');
  var fFotoYazi = root.querySelector('[data-petp-foto-yazi]');
  var fFotoSil = root.querySelector('[data-petp-foto-sil]');
  var fFotoMsg = root.querySelector('[data-petp-foto-msg]');

  // ---------- Pati fotoğrafı (16 Eki 2026) ----------
  // İsteğe bağlı. Seçilen fotoğraf tarayıcıda küçültülür (uzun kenar 800 px, JPEG ~0.8, ≤600 KB), app proxy
  // /apps/pet-profil/foto'ya base64 gider (worker: imzalı müşteri, ≤1 MB, yalnız JPEG/PNG, R2). Dönen url pet.foto'ya
  // yazılır. Kayıtlı pette değişiklik ANINDA kaydedilir (worker aynı petin eski fotoğrafını hemen siler — form
  // "Vazgeç"le kapansa bile profil yeni url'yi göstermeli). Yeni pette url form kaydıyla yazılır; kaydedilmezse worker
  // 10 dk sonra temizler. Görsel açılamazsa tür ikonu (onerror → aşağıdaki yakalayıcı).
  var formFoto = null, formYeniId = null, fotoMesgul = false;
  function yeniId() { return 'p' + Date.now().toString(36) + Math.floor(Math.random() * 1e4).toString(36); }
  function avatarIc(url, tur) {
    var em = TUR_EMOJI[tur] || '';
    return url ? '<img class="petp__foto-img" src="' + esc(url) + '" alt="" loading="lazy" width="88" height="88" data-yedek-tur="' + esc(tur || '') + '">' : em;
  }
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.classList.contains('petp__foto-img')) {
      var kap = t.parentNode;
      if (kap) { kap.classList.remove('has-foto'); kap.innerHTML = TUR_EMOJI[t.getAttribute('data-yedek-tur')] || ''; }
    }
  }, true);
  function fotoMsg(m, hata) {
    if (!fFotoMsg) return;
    fFotoMsg.textContent = m || '';
    fFotoMsg.classList.toggle('is-hata', !!hata);
  }
  function avatarCiz() {
    if (!fFotoAv) return;
    var tur = getChips(fTur)[0] || 'kedi';
    fFotoAv.innerHTML = avatarIc(formFoto, tur);
    fFotoAv.classList.toggle('has-foto', !!formFoto);
    if (fFotoYazi) fFotoYazi.textContent = fotoMesgul ? _t('pp_yukleniyor', 'Yükleniyor…') : (formFoto ? _t('pp_foto_degistir', 'Fotoğrafı değiştir') : _t('pp_foto_ekle', 'Fotoğraf ekle'));
    if (fFotoSil) fFotoSil.hidden = !formFoto || fotoMesgul;
  }
  function fotoDurum(m) {
    fotoMesgul = m;
    if (fFotoBtn) fFotoBtn.classList.toggle('is-yukleniyor', m);
    if (fFotoIn) fFotoIn.disabled = m;
    if (fFotoAv) fFotoAv.classList.toggle('is-yukleniyor', m);
    avatarCiz();
  }
  var FOTO_EN_COK = 600 * 1024;
  function kucult(file) {
    return new Promise(function (ok, no) {
      var u = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(u);
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return no(new Error(_t('pp_foto_okunamadi', 'Fotoğraf okunamadı.')));
        var k = Math.min(1, 800 / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        var x = c.getContext('2d');
        x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); // PNG saydamlığı JPEG'de siyah olmasın
        x.drawImage(img, 0, 0, c.width, c.height);
        var q = 0.8;
        (function dene() {
          c.toBlob(function (b) {
            if (!b) return no(new Error(_t('pp_foto_hazirlanamadi', 'Fotoğraf hazırlanamadı.')));
            if (b.size > FOTO_EN_COK && q > 0.45) { q -= 0.1; return dene(); }
            ok(b);
          }, 'image/jpeg', q);
        })();
      };
      img.onerror = function () { URL.revokeObjectURL(u); no(new Error(_t('pp_dosya_acilamadi', 'Bu dosya açılamadı. JPEG ya da PNG bir fotoğraf seç.'))); };
      img.src = u;
    });
  }
  function b64(blob) {
    return new Promise(function (ok, no) {
      var r = new FileReader();
      r.onload = function () { ok(String(r.result)); };
      r.onerror = function () { no(new Error(_t('pp_foto_okunamadi', 'Fotoğraf okunamadı.'))); };
      r.readAsDataURL(blob);
    });
  }
  function fotoHata(st, d) {
    if (d && d.mesaj) return d.mesaj;
    if (st === 401) return _t('pp_foto_401', 'Fotoğraf eklemek için giriş yapmalısın.');
    if (st === 413) return _t('pp_foto_413', 'Fotoğraf çok büyük (en çok 1 MB).');
    if (st === 415) return _t('pp_foto_415', 'Yalnız JPEG ya da PNG fotoğraf yüklenebilir.');
    if (st === 429) return _t('pp_foto_429', 'Çok fazla fotoğraf yüklendi; biraz sonra tekrar dene.');
    return _t('pp_foto_hata', 'Fotoğraf şu an yüklenemedi, tekrar dene.');
  }
  function kayitliPet(id) { return pets().filter(function (p) { return p.id === id; })[0]; }
  function fotoYukle(file) {
    if (fotoMesgul || !file) return;
    if (file.type && !/^image\//.test(file.type)) { fotoMsg(_t('pp_foto_sec', 'Lütfen bir fotoğraf seç.'), true); return; }
    var petId = fId.value || formYeniId;
    fotoMsg('');
    fotoDurum(true);
    kucult(file).then(b64).then(function (data) {
      return fetch('/apps/pet-profil/foto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ petId: petId, data: data })
      });
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok || !d || !d.url) throw new Error(fotoHata(r.status, d));
        return d.url;
      });
    }).then(function (url) {
      formFoto = url;
      var p = kayitliPet(petId);
      if (p) { p.foto = url; persist(); }
      fotoMsg(p ? _t('pp_foto_kaydedildi', 'Fotoğraf kaydedildi.') : _t('pp_foto_hazir', 'Fotoğraf hazır; kaydedince profile eklenir.'));
    }).catch(function (e) {
      fotoMsg((e && e.message) || _t('pp_foto_hata', 'Fotoğraf şu an yüklenemedi, tekrar dene.'), true);
    }).then(function () {
      fotoDurum(false);
      if (fFotoIn) fFotoIn.value = '';
    });
  }
  function fotoSilSunucu(petId) {
    if (!boot.loggedIn || !petId) return;
    fetch('/apps/pet-profil/foto-sil', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ petId: petId })
    }).catch(function () { /* worker kayıt sonrası temizliği de siler */ });
  }
  if (fFotoIn) fFotoIn.addEventListener('change', function () { fotoYukle(fFotoIn.files && fFotoIn.files[0]); });
  if (fFotoSil) fFotoSil.addEventListener('click', function () {
    var petId = fId.value || formYeniId;
    formFoto = null;
    fotoSilSunucu(petId);
    var p = kayitliPet(petId);
    if (p) { p.foto = null; persist(); }
    fotoMsg(_t('pp_foto_kaldirildi', 'Fotoğraf kaldırıldı.'));
    avatarCiz();
  });

  (function fillSelects() {
    var y = new Date().getFullYear();
    var html = '<option value="">' + _t('pp_bilinmiyor', 'Bilinmiyor') + '</option>';
    for (var i = y; i >= y - 25; i--) html += '<option value="' + i + '">' + i + '</option>';
    fYil.innerHTML = html;
    var ah = '<option value="">—</option>';
    for (var m = 1; m <= 12; m++) ah += '<option value="' + m + '">' + AYLAR[m - 1] + '</option>';
    fAy.innerHTML = ah;
  })();

  // Irk listesini türe göre doldur; listede olmayan mevcut değer (eski kayıt) kaybolmasın
  function fillBreeds(tur, current) {
    var list = BREEDS[tur] || [];
    var html = '<option value="">' + _t('pp_seciniz', 'Seçiniz (isteğe bağlı)') + '</option>';
    var found = false;
    list.forEach(function (b) {
      if (b === current) found = true;
      html += '<option value="' + esc(b) + '">' + esc(irkAd(b)) + '</option>';
    });
    if (current && !found) html += '<option value="' + esc(current) + '">' + esc(irkAd(current)) + '</option>';
    fIrk.innerHTML = html;
    fIrk.value = current || '';
  }

  function setChips(container, values) {
    var arr = [].concat(values || []).map(function (v) { return String(v).toLowerCase(); });
    container.querySelectorAll('.petp__chip').forEach(function (c) {
      c.classList.toggle('is-active', arr.indexOf(c.getAttribute('data-val')) >= 0);
    });
  }
  function getChips(container) {
    return Array.prototype.map.call(container.querySelectorAll('.petp__chip.is-active'), function (c) {
      return c.getAttribute('data-val');
    });
  }

  function showList() {
    formView.hidden = true;
    listView.hidden = false;
    titleEl.textContent = _t('pati_profili', 'Pati Profili');
    renderList();
    // Pati karakteri sitede GÖSTERİLMEZ (16 Eki gece kararı: karakter app'in sekme çubuğunda yaşar; sitede sekme çubuğu yok —
    // app'e özgü, tek izinli fark). karakterSahne/karakterOyuncu ileride site tasarımı için duruyor, çağrılmıyor.
  }

  function showForm(pet) {
    listView.hidden = true;
    formView.hidden = false;
    titleEl.textContent = pet ? pet.ad : _t('pp_yeni_dost', 'Yeni Dost');
    fId.value = pet ? pet.id : '';
    fAd.value = pet ? pet.ad : '';
    var formTur = (pet && pet.tur === 'kopek') ? 'kopek' : (pet && pet.tur === 'kedi' ? 'kedi' : (pet ? pet.tur : 'kedi'));
    setChips(fTur, formTur);
    fillBreeds(formTur, (pet && pet.irk) || '');
    var dg = pet && pet.dogum ? String(pet.dogum).split('-') : [];
    fYil.value = dg[0] || '';
    fAy.value = dg[1] ? String(+dg[1]) : '';
    fKilo.value = (pet && pet.kilo) || '';
    setChips(fCinsiyet, pet ? pet.cinsiyet : []);
    fKisir.checked = !!(pet && pet.kisir);
    setChips(fAlerji, pet ? pet.alerji : []);
    fDelete.hidden = !pet;
    formFoto = (pet && pet.foto) || null;
    formYeniId = pet ? null : yeniId();
    fotoMsg('');
    avatarCiz();
  }

  // ---------- Liste görünümü: Pati Profili ekranı (3 Kas 2026, Faz 1 — onaylı önizleme docs/onizleme/pati, tuval
  // JLsP8z5LU4skdh4d1LxZRY; app Pati sekmesi birebir). Dost seçici + büyük avatar + 3 sayı (günlük gram, mamanın kalan
  // günü, doğum ayı) + "Yaklaşanlar" (mama bitişi, doğum günü) + "[ad] için seçtiklerimiz" (Hangi Mama? motoru) +
  // "Hangi mama?" satırı + Club satırı. Faz 2'de aşı/parazit takvimi ve kilo günlüğü, Faz 3'te karne ve Pati Kartı gelir.
  var SV = {
    kamera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.2"/></svg>',
    arti: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    pasta: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 21h16"/><path d="M5 21v-7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7"/><path d="M8 12V9M12 12V8M16 12V9"/><path d="M5 16c1.5 1 3 1 4.5 0s3-1 4.5 0 3 1 5 0"/></svg>',
    soru: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.4-1 .9-1 1.7"/><circle cx="12" cy="17" r=".6" fill="currentColor"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>',
    tik: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></svg>',
    zil: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 8 3 8H3s3-1 3-8"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>',
    yildiz: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l2.6 5.6 6 .7-4.5 4.1 1.2 6L12 16.5 6.7 19.4l1.2-6L3.4 9.3l6-.7z"/></svg>'
  };
  var SEC_LS = 'petidi_pati_secili';
  var seciliId = null;
  try { seciliId = localStorage.getItem(SEC_LS); } catch (e) {}
  // Ayın Türkçe bulunma ekiyle hâli (Ocak'ta, Nisan'da, Eylül'de); başka dilde "in January"
  var AY_TA = ['Ocak\'ta', 'Şubat\'ta', 'Mart\'ta', 'Nisan\'da', 'Mayıs\'ta', 'Haziran\'da', 'Temmuz\'da', 'Ağustos\'ta', 'Eylül\'de', 'Ekim\'de', 'Kasım\'da', 'Aralık\'ta'];
  function ayAdi(m, kisa) {
    try { return new Date(2026, m - 1, 15).toLocaleDateString(_t('yerel', 'tr-TR'), { month: kisa ? 'short' : 'long' }); } catch (e) { return String(m); }
  }
  // Doğum günü: { ay, kisa, yas, buAy } — yalnız ay biliniyorsa (dogum "YYYY-MM"); yas = gireceği yaş
  function dogumBilgi(dogum) {
    var m = /^(\d{4})-(\d{1,2})/.exec(String(dogum || ''));
    if (!m) return null;
    var y = +m[1], ay = +m[2], now = new Date(), nAy = now.getMonth() + 1, yas = now.getFullYear() - y;
    if (ay < nAy) yas += 1;
    if (yas < 1) return null;
    return { ay: ay, kisa: ayAdi(ay, true), uzun: ayAdi(ay, false), yas: yas, buAy: ay === nAy };
  }
  function secili(list) {
    for (var i = 0; i < list.length; i++) if (list[i].id === seciliId) return list[i];
    return list[0];
  }
  function bosEkran() {
    var fayda = function (ik, b, t) {
      return '<li class="pps__fayda"><span class="pps__ik">' + ik + '</span><span><strong>' + b + '</strong><small>' + t + '</small></span></li>';
    };
    return '<div class="pps pps--bos">' +
      '<div class="pps__bos-av" aria-hidden="true"><span class="pps__bos-a">' + (IK.cat || '') + '</span><span class="pps__bos-b">' + (IK.dog || '') + '</span></div>' +
      '<h2 class="pps__bos-baslik">' + _t('pps_bos_baslik', 'Dostunu tanıt') + '</h2>' +
      '<p class="pps__bos-alt">' + _t('pps_bos_alt', 'Mamasının ne kadar yeteceğini hesaplayalım, bitmeden haber verelim, ona uygun olanı gösterelim.') + '</p>' +
      '<ul class="pps__faydalar">' +
      fayda(SV.zil, _t('pps_f1_b', 'Maması bitmeden haber'), _t('pps_f1_t', 'Kilosuna göre "kaç gün yeter" hesabı, bitmeye yakın WhatsApp ya da bildirim.')) +
      fayda(IK.spark || SV.yildiz, _t('pps_f2_b', 'Ona uygun mamalar'), _t('pps_f2_t', 'Yaşına, kısırlığına ve alerjisine göre işaretli öneriler.')) +
      fayda(SV.pasta, _t('pps_f3_b', 'Doğum gününe sürpriz'), _t('pps_f3_t', 'Doğum ayında ona özel sürpriz indirim.')) +
      (!CP.uye ? fayda(IK.club || IK.gift || '', _t('pps_f4_b', 'Petidi Club ücretsiz açılır'), _t('pps_f4_t', 'Siparişlerinde Club hediyeleri; ücret yok.')) : '') +
      '</ul>' +
      '<div class="pps__bos-alt-btn">' +
      '<button type="button" class="pps__btn-ana" data-petp-new>' + _t('pps_dost_ekle', 'Dostunu ekle') + '</button>' +
      '<button type="button" class="pps__btn-ikinci" data-quiz-open>' + _t('pps_once_test', 'Önce "Hangi mama?" testi') + '</button>' +
      '<p class="pps__bos-not">' + _t('pps_bos_not', '30 saniye sürer · yalnız adı ve türü zorunlu') + '</p>' +
      '</div></div>';
  }
  function renderList() {
    if (!listEl) return;
    var list = pets();
    if (!list.length) {
      listEl.innerHTML = bosEkran();
      if (guestNote) guestNote.hidden = true;
      return;
    }
    var p = secili(list);
    // Dost seçici
    var h = '<div class="pps"><div class="pps__secici" role="tablist" aria-label="' + _t('pps_dostlar', 'Dostların') + '">' +
      list.map(function (d) {
        var on = d.id === p.id;
        return '<button type="button" class="pps__dost' + (on ? ' is-on' : '') + '" role="tab" aria-selected="' + (on ? 'true' : 'false') + '" data-pps-sec="' + esc(d.id) + '">' +
          '<span class="pps__dost-av' + (d.foto ? ' has-foto' : '') + '">' + avatarIc(d.foto, d.tur) + '</span><span class="pps__dost-ad">' + esc(d.ad) + '</span></button>';
      }).join('') +
      '<button type="button" class="pps__dost pps__dost--ekle" data-petp-new><span class="pps__dost-av">' + SV.arti + '</span><span class="pps__dost-ad">' + _t('pps_ekle', 'Ekle') + '</span></button>' +
      '</div>';
    // Büyük avatar + ad + bilgiler
    var meta = [TUR_LABEL[p.tur] || p.tur];
    if (p.irk) meta.push(irkAd(p.irk));
    var al = ageLabel(p.dogum);
    if (al) meta.push(al);
    if (p.kilo) meta.push(String(p.kilo).replace('.', _t('ondalik', ',')) + ' kg');
    if (p.kisir) meta.push(_t('pps_kisir', 'kısır'));
    h += '<div class="pps__kahraman">' +
      '<div class="pps__buyuk"><span class="pps__buyuk-av' + (p.foto ? ' has-foto' : '') + '">' + avatarIc(p.foto, p.tur) + '</span>' +
      '<button type="button" class="pps__foto-btn" data-petp-edit-card="' + esc(p.id) + '" aria-label="' + (p.foto ? _t('pp_foto_degistir', 'Fotoğrafı değiştir') : _t('pp_foto_ekle', 'Fotoğraf ekle')) + '">' + SV.kamera + '</button></div>' +
      '<h2 class="pps__ad">' + esc(p.ad) + '</h2>' +
      '<p class="pps__meta">' + esc(meta.join(' · ')) + '</p>' +
      '<button type="button" class="pps__duzenle" data-petp-edit-card="' + esc(p.id) + '">' + _t('pps_duzenle', 'Düzenle') + '</button></div>';
    // Üç sayı: günlük mama · kalan gün · doğum günü
    var lf = (p.tur === 'kedi' || p.tur === 'kopek') ? purchaseFor(p.tur) : null;
    var inf = lf ? reorderInfo(lf) : null;
    var g = dailyGrams(p, lf ? lf.b : null);
    var dg = dogumBilgi(p.dogum);
    var sayi = function (deger, etiket, cls) { return '<div class="pps__sayi' + (cls ? ' ' + cls : '') + '"><b>' + deger + '</b><small>' + etiket + '</small></div>'; };
    var duzBtn = function (metin) { return '<button type="button" class="pps__sayi-ekle" data-petp-edit-card="' + esc(p.id) + '">' + metin + '</button>'; };
    var gunDeger = '—', gunCls = '';
    if (inf && inf.mode) {
      if (inf.mode === 'out') { gunDeger = _t('pps_bitti', 'bitti'); gunCls = 'is-uyari'; }
      else { gunDeger = _tn('pps_n_gun', inf.kalan, '[n] gün'); if (inf.mode === 'soon') gunCls = 'is-uyari'; }
    }
    h += '<div class="pps__sayilar">' +
      sayi(p.kilo && g ? '~' + (g >= 20 ? Math.round(g / 5) * 5 : Math.round(g)) + ' g' : duzBtn(_t('pps_kilo_ekle', 'Kilo ekle')), _t('pps_gunluk', 'günlük mama')) +
      sayi(gunDeger, _t('pps_kalan', 'maması kaldı'), gunCls) +
      sayi(dg ? esc(dg.kisa) : duzBtn(_t('pps_ay_ekle', 'Ay ekle')), _t('pps_dogum', 'doğum günü')) +
      '</div>';
    // Yaklaşanlar
    var sat = [];
    if (lf && inf && inf.mode) {
      var oran = inf.toplam ? Math.max(0, Math.min(1, inf.kalan / inf.toplam)) : 0;
      var halka = '<span class="pps__halka' + (inf.mode === 'early' ? '' : ' is-uyari') + '"><svg viewBox="0 0 44 44" aria-hidden="true"><circle cx="22" cy="22" r="18" class="pps__halka-iz"/><circle cx="22" cy="22" r="18" class="pps__halka-dolu" stroke-dasharray="113" stroke-dashoffset="' + Math.round(113 * (1 - oran)) + '" transform="rotate(-90 22 22)"/></svg><span>%' + Math.round(oran * 100) + '</span></span>';
      var bas = inf.mode === 'out' ? _t('pps_mama_bitti', 'Maması bitmiş olmalı') : (inf.mode === 'soon' ? _t('pps_mama_bitiyor', 'Maması bitmek üzere') : _t('pps_mama_yeter', 'Maması yetiyor'));
      var alt = esc(lf.t) + (lf.vt ? ' · ' + esc(lf.vt) : '') + (inf.mode === 'out' ? '' : ' · ' + _tn('pp_gun_kaldi', inf.kalan, '~[n] gün kaldı'));
      sat.push('<div class="pps__satir">' + halka + '<span class="pps__satir-y"><strong>' + bas + '</strong><small>' + alt + '</small></span>' + reorderBtn(lf, 'pps__tekrar') + '</div>');
    }
    if (dg) {
      sat.push('<div class="pps__satir"><span class="pps__ik">' + SV.pasta + '</span><span class="pps__satir-y"><strong>' + _t('pps_dogum_gunu', 'Doğum günü') + '</strong><small>' +
        (dg.buAy ? _t('pps_dg_buay', 'Bu ay [yas] yaşına giriyor · doğum gününe özel sürpriz indirim', { yas: dg.yas })
          : _t('pps_dg_alt', '[ay] [yas] yaşına giriyor · doğum gününe özel sürpriz indirim', { ay: _t('yerel', 'tr-TR') === 'tr-TR' ? AY_TA[dg.ay - 1] : dg.uzun, yas: dg.yas })) +
        '</small></span></div>');
    }
    if (sat.length) h += '<h3 class="pps__bolum">' + _t('pps_yaklasanlar', 'Yaklaşanlar') + '</h3><div class="pps__satirlar">' + sat.join('') + '</div>';
    // [ad] için seçtiklerimiz (Hangi Mama? motoru; çekmece açılınca oneriDoldur doldurur)
    if (p.tur === 'kedi' || p.tur === 'kopek') {
      h += '<div class="pps__oneri" data-pps-oneri="' + esc(p.id) + '" hidden><h3 class="pps__bolum">' + _t('pps_secilenler', '[ad] için seçtiklerimiz', { ad: esc(p.ad) }) + '</h3><div class="pps__raf" data-pps-raf></div></div>';
    }
    // Hangi mama? satırı
    h += '<div class="pps__linkler"><button type="button" class="pps__link" data-quiz-open><span class="pps__ik">' + SV.soru + '</span><span class="pps__satir-y"><strong>' + _t('pps_hangi', 'Hangi mama?') + '</strong><small>' +
      _t('pps_hangi_alt', '[ad]\'a uygun mamaları yeniden listele', { ad: esc(p.ad) }) + '</small></span><span class="pps__ok">' + SV.ok + '</span></button></div>';
    if (CP.uye) h += '<p class="pps__club"><span class="pps__club-ik">' + SV.tik + '</span><span>' + _t('pps_club_uye', '<strong>Petidi Club üyesisin.</strong> Siparişlerinde Club hediyeleri seni bekliyor.') + '</span></p>';
    h += '</div>';
    listEl.innerHTML = h;
    if (guestNote) guestNote.hidden = false;
    if (!root.hidden) oneriDoldur();
  }
  // "[ad] için seçtiklerimiz" rafı: pet-quiz.js (profil varsa sayfayla yüklenir) PetidiQuiz.oneri; yoksa raf gizli kalır
  var oneriCache = {};
  function oneriCiz(kap, recs, pet) {
    if (!recs || !recs.length) { kap.hidden = true; return; }
    var raf = kap.querySelector('[data-pps-raf]');
    raf.innerHTML = recs.map(function (r, i) {
      var gunN = r.gun >= 10 ? Math.round(r.gun / 5) * 5 : r.gun;
      return '<a class="pps__urun" href="' + esc(r.u) + '">' +
        '<span class="pps__urun-img">' + (r.img ? '<img src="' + esc(r.img) + '" alt="" loading="lazy" width="150" height="150">' : (IK.paw || '')) +
        (i === 0 ? '<span class="pps__urun-rozet">' + _t('pps_onerilen', '[ad] için önerilen', { ad: esc(pet.ad) }) + '</span>' : '') + '</span>' +
        '<span class="pps__urun-ad">' + esc(r.t) + (r.kg ? ' ' + String(r.kg).replace('.', _t('ondalik', ',')) + ' kg' : '') + '</span>' +
        '<span class="pps__urun-fiyat">' + tlPrice(r.f) + '</span>' +
        (r.gun ? '<span class="pps__urun-gun">' + _t('pp_yeter', '[gun] yeter', { gun: r.gun > 120 ? _t('pp_120_gun', '120+ gün') : _tn('pp_yak_gun', gunN, '~[n] gün') }) + '</span>' : '') +
        '</a>';
    }).join('');
    kap.hidden = false;
  }
  function oneriDoldur() {
    var kap = listEl && listEl.querySelector('[data-pps-oneri]');
    if (!kap) return;
    var pet = kayitliPet(kap.getAttribute('data-pps-oneri'));
    if (!pet || !window.PetidiQuiz) return;
    var anahtar = [pet.id, pet.tur, pet.dogum, pet.kilo, pet.kisir, (pet.alerji || []).join(',')].join('|');
    if (oneriCache[anahtar]) { oneriCiz(kap, oneriCache[anahtar], pet); return; }
    window.PetidiQuiz.oneri(pet, 3).then(function (r) {
      oneriCache[anahtar] = r;
      var k2 = listEl.querySelector('[data-pps-oneri="' + pet.id + '"]');
      if (k2) oneriCiz(k2, r, pet);
    }).catch(function () { kap.hidden = true; });
  }
  document.addEventListener('petidi:quiz-hazir', function () { if (!root.hidden) oneriDoldur(); });

  // ---------- Pati karakteri (16 Eki 2026) ----------
  // Kütüphane yalnız GİRİŞLİ müşteriye, app proxy üzerinden (POST /apps/pet-profil/karakter → worker → ahtapot): gösterim
  // kapısı ahtapot'ta (panel: kapalı / yalnız test hesapları / herkes; varsayılan kapalı). Karakter yalnız `pet.karakter`
  // ATANMIŞ pette görünür (atama: panel › Pati Karakteri › Galeri › "Pete ata"); varsayılan karakter yok.
  // Oynatıcı (karakterOyuncu) her kaba takılabilir — v1'de yalnız çekmecede başlığın altındaki şerit; v2'de sayfanın herhangi
  // bir yerine overlay (position:absolute, z-index) olarak konur. Çerçevesiz: beyaz zeminli klip multiply'la sayfaya karışır,
  // kedi sayfanın üstünde duruyor gibi. İlk gösterimde başlığın altından yukarı kayarak çıkar; "boşta" klibi bir kez; 20–40 sn'de
  // bir rastgele sahne, bitince boşta (döngü yok, ses yok). Yürüme kliplerinde kutu klip süresince x ekseninde kayar (sağa yürüme
  // soldan sağa). Dokununca zıplama klibi, yoksa kodla zıplama. Hareket azaltma açıksa yalnız portre. Eski bantlı klip (16:9
  // içinde 3:4) `icerik` oranına kırpılır — beyaz multiply'la kaybolur ama siyah bant kaybolmaz, o yüzden kırpma şart.
  var KS = { kut: null, yukleniyor: null, oyuncu: null };
  function kutuphaneAl() {
    if (!boot.loggedIn) return Promise.resolve(null);
    if (KS.kut) return Promise.resolve(KS.kut);
    if (KS.yukleniyor) return KS.yukleniyor;
    try {
      var c = JSON.parse(sessionStorage.getItem('petidi_karakter_kut') || 'null');
      if (c && Date.now() - c.t < 10 * 60e3) { KS.kut = c.d; return Promise.resolve(c.d); }
    } catch (e) {}
    KS.yukleniyor = fetch('/apps/pet-profil/karakter', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        KS.kut = d && d.portreler ? d : { portreler: [], klipler: [] };
        try { sessionStorage.setItem('petidi_karakter_kut', JSON.stringify({ t: Date.now(), d: KS.kut })); } catch (e) {}
        return KS.kut;
      }).catch(function () { KS.kut = { portreler: [], klipler: [] }; return KS.kut; });
    return KS.yukleniyor;
  }
  /** Atanmış karakter: petin karakter.preset'i kütüphanede (onaylı + kapı açık) olmalı; değilse null. */
  function karakterSec(kut, pet) {
    var istenen = pet && pet.karakter && pet.karakter.preset;
    if (!kut || !istenen) return null;
    var sec = (kut.portreler || []).filter(function (x) { return x.preset === istenen; })[0];
    if (!sec) return null;
    var kl = (kut.klipler || []).filter(function (x) { return x.preset === sec.preset; });
    var ilk = function (ad) { return kl.filter(function (x) { return x.sahne === ad; })[0] || null; };
    return { portre: sec, klipler: kl, bosta: ilk('idle'), zipla: ilk('zipla-yildiz'), sahneler: kl.filter(function (x) { return x.sahne !== 'idle'; }) };
  }
  var azHareket = function () { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } };
  // Klip çerçevesi: içerik oranı videonunkinden farklıysa (bant) video taşırılır, kutu kırpar
  function klipYerlestir(kutu, v, klip) {
    var vOran = klip.enBoy === '9:16' ? 9 / 16 : 16 / 9, iOran = klip.icerik || vOran;
    kutu.style.aspectRatio = iOran.toFixed(4);
    // %2 taşma payı: yuvarlamadan kenarda 1 px siyah bant sızmasın (16 Eki testinde görüldü)
    var en = iOran < vOran ? vOran / iOran * 1.02 : 1, boy = iOran > vOran ? iOran / vOran * 1.02 : 1;
    v.style.width = (en * 100).toFixed(2) + '%'; v.style.height = (boy * 100).toFixed(2) + '%';
    v.style.left = (-(en - 1) / 2 * 100).toFixed(2) + '%'; v.style.top = (-(boy - 1) / 2 * 100).toFixed(2) + '%';
  }
  /**
   * Oynatıcı: kap (şerit ya da v2'de overlay kabı) içine kutuyu kurar. k: karakterSec sonucu. Dönen { kapat }.
   * Kutu kabın içinde yatayda kayabilir (yürüme); x durumu oyuncuda tutulur.
   */
  function karakterOyuncu(kap, k) {
    var zaman = null, x = 0, kapandi = false;
    var oran = k.portre.en && k.portre.boy ? k.portre.en / k.portre.boy : 16 / 9;
    kap.innerHTML = '<button type="button" class="petp__sahne-kutu is-cikis" data-petp-sahne-kutu aria-label="' + _t('pp_karakter_aria', 'Pati karakteri — dokun, zıplasın') + '" style="aspect-ratio:' + oran.toFixed(4) + '">' +
      '<span class="petp__sahne-ic">' +
      '<img class="petp__sahne-portre" src="' + esc(k.portre.url) + '" alt="" width="' + (k.portre.en || 1280) + '" height="' + (k.portre.boy || 720) + '">' +
      '<span class="petp__sahne-video" hidden><video muted playsinline preload="metadata" disablepictureinpicture></video></span></span></button>';
    var kutu = kap.querySelector('[data-petp-sahne-kutu]'), vkap = kap.querySelector('.petp__sahne-video'), v = vkap.querySelector('video');
    setTimeout(function () { kutu.classList.remove('is-cikis'); }, 700);
    var konum = function (yeni, sure) {
      var sinir = Math.max(0, (kap.clientWidth - kutu.offsetWidth) / 2);
      x = Math.max(-sinir, Math.min(sinir, yeni));
      kutu.style.transition = 'transform ' + (sure || 0) + 's linear';
      kutu.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
    };
    var planla = function () {
      clearTimeout(zaman);
      if (kapandi || !k.sahneler.length || azHareket()) return;
      zaman = setTimeout(function () {
        if (kapandi || !document.body.contains(kap) || root.hidden) return planla();   // çekmece kapalıyken oynamaz
        oynat(k.sahneler[Math.floor(Math.random() * k.sahneler.length)]);
      }, (20 + Math.random() * 20) * 1000);
    };
    var oynat = function (klip) {
      clearTimeout(zaman);
      if (kapandi || !klip || azHareket()) return planla();
      v.onended = function () { if (klip !== k.bosta && k.bosta) oynat(k.bosta); else planla(); };   // son kare ekranda kalır
      v.onplaying = function () {
        vkap.hidden = false; kutu.classList.add('is-video');
        // Yürüme: kutu klip süresince yürüme yönünde kayar (sağa yürüme soldan sağa)
        var sure = isFinite(v.duration) && v.duration > 0 ? v.duration : (klip.sure || 6);
        var sinir = Math.max(0, (kap.clientWidth - kutu.offsetWidth) / 2);
        if (klip.sahne === 'yuru-sag') konum(sinir, sure);
        else if (klip.sahne === 'yuru-sol') konum(-sinir, sure);
      };
      v.onerror = function () { vkap.hidden = true; kutu.classList.remove('is-video'); planla(); };
      klipYerlestir(kutu, v, klip);
      if (v.getAttribute('src') !== klip.url) v.src = klip.url; else v.currentTime = 0;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () { planla(); });
    };
    kutu.addEventListener('click', function () {
      if (k.zipla && !azHareket()) { oynat(k.zipla); return; }
      kutu.classList.remove('is-zipla'); void kutu.offsetWidth; kutu.classList.add('is-zipla');
    });
    if (!azHareket() && k.klipler.length) { if (k.bosta) oynat(k.bosta); else planla(); }
    return { kapat: function () { kapandi = true; clearTimeout(zaman); try { v.pause(); } catch (e) {} } };
  }
  function karakterSahne() {
    var kok = root.querySelector('[data-petp-sahne]');
    if (!kok) return;
    var pet = pets().filter(function (p) { return p && p.karakter && p.karakter.preset; })[0];
    if (!pet) { kok.hidden = true; return; }
    kutuphaneAl().then(function (kut) {
      var k = karakterSec(kut, pet);
      if (!k) { kok.hidden = true; return; }
      if (KS.oyuncu && KS.oyuncu.url === k.portre.url && kok.firstChild) { kok.hidden = false; return; }   // zaten bu karakter
      if (KS.oyuncu) KS.oyuncu.o.kapat();
      kok.hidden = false;
      KS.oyuncu = { url: k.portre.url, o: karakterOyuncu(kok, k) };
    });
  }

  function openDrawer(editId) {
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    if (editId) {
      var pet = pets().filter(function (p) { return p.id === editId; })[0];
      showForm(pet || null);
    } else {
      showList();
    }
  }

  function closeDrawer() {
    root.hidden = true;
    document.body.style.overflow = '';
  }

  // ---------- Olaylar ----------
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-petp-open]');
    // data-petp-yeni (1 Kas 2026, kullanıcı): liste / "Hangi mama?" yerine doğrudan yeni dost formu (abonelik sıklık önerisi, Nasıl çalışır?)
    if (opener) { e.preventDefault(); if (opener.hasAttribute('data-petp-yeni') && !opener.getAttribute('data-petp-edit')) { openDrawer(null); showForm(null); } else openDrawer(opener.getAttribute('data-petp-edit')); return; }
    if (e.target.closest('[data-petp-close]')) { closeDrawer(); return; }

    // "Tekrar Al": aynı varyantı sepete ekle
    var ra = e.target.closest('[data-reorder-add]');
    if (ra) {
      ra.disabled = true;
      var raText = ra.textContent;
      fetch(KOK + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: +ra.getAttribute('data-reorder-add'), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        if (window.petidiUpdateCartCount) window.petidiUpdateCartCount();
        ra.textContent = _t('sepete_eklendi_tik', '✓ Sepete eklendi');
      }).catch(function () {
        ra.disabled = false;
        ra.textContent = raText;
        window.alert(_t('qa_hata', 'Ürün eklenemedi, lütfen tekrar deneyin.'));
      });
      return;
    }
    // "Tekrar Al" şeridini kapat (aynı alım için bir daha gösterme)
    if (e.target.closest('[data-reorder-close]')) {
      var rw = e.target.closest('[data-pet-reorder]');
      if (rw) {
        try {
          localStorage.setItem(REORDER_LS, rw.getAttribute('data-reorder-key') || '');
          localStorage.removeItem('petidi_tekrar_h');
        } catch (err) {}
        rw.hidden = true;
        rw.style.minHeight = '';
      }
      return;
    }
    // Varyant değişince rozeti ve "hangi boy?" şeridini tazele
    // (product.js seçimi işledikten ve seçim ÇİZİLDİKTEN sonra — INP, 17 Eki 2026: rAF → setTimeout)
    if (e.target.closest('.pd__variant')) {
      var tazele = function () { renderBadge(); renderSizeQ(); renderSiklik(); };
      if (window.petidiBoyaSonra) window.petidiBoyaSonra(tazele); else window.setTimeout(tazele, 0);
    }
    var cardVariant = e.target.closest('[data-card-variant]');
    if (cardVariant) {
      var pc = cardVariant.closest('.pcard');
      if (pc) window.setTimeout(function () { renderCardBadges(pc); }, 0);
    }
  });

  root.addEventListener('click', function (e) {
    var card = e.target.closest('[data-petp-edit-card]');
    if (card) {
      showForm(pets().filter(function (p) { return p.id === card.getAttribute('data-petp-edit-card'); })[0]);
      return;
    }
    var sec = e.target.closest('[data-pps-sec]');
    if (sec) { seciliId = sec.getAttribute('data-pps-sec'); try { localStorage.setItem(SEC_LS, seciliId); } catch (er) {} renderList(); return; }
    if (e.target.closest('[data-petp-new]')) { showForm(null); return; }
    if (e.target.closest('[data-petp-cancel]')) { showList(); return; }

    var chip = e.target.closest('.petp__chip');
    if (chip) {
      var group = chip.parentElement;
      if (group === fTur || group === fCinsiyet) {
        var wasActive = chip.classList.contains('is-active');
        group.querySelectorAll('.petp__chip').forEach(function (c) { c.classList.remove('is-active'); });
        if (group === fTur || !wasActive) chip.classList.add('is-active');
        if (group === fTur) { fillBreeds(chip.getAttribute('data-val'), ''); avatarCiz(); }
      } else {
        chip.classList.toggle('is-active');
      }
      return;
    }

    if (e.target.closest('[data-petp-delete]')) {
      var id = fId.value;
      var pet = pets().filter(function (p) { return p.id === id; })[0];
      if (pet && window.confirm(_t('pp_sil_onay', '[ad] profilini silmek istediğine emin misin?', { ad: pet.ad }))) {
        profile.petler = pets().filter(function (p) { return p.id !== id; });
        if (pet.foto) fotoSilSunucu(id);
        persist();
        showList();
      }
    }
  });

  formView.addEventListener('submit', function (e) {
    e.preventDefault();
    var ad = fAd.value.trim();
    if (!ad) { fAd.focus(); return; }

    var existing = pets().filter(function (p) { return p.id === fId.value; })[0] || {};
    var pet = {};
    for (var k in existing) { if (Object.prototype.hasOwnProperty.call(existing, k)) pet[k] = existing[k]; }

    if (fotoMesgul) { fotoMsg(_t('pp_foto_bekle', 'Fotoğraf yükleniyor, birazdan tekrar dene.'), true); return; }
    pet.id = fId.value || formYeniId || yeniId();
    pet.ad = ad;
    pet.tur = getChips(fTur)[0] || 'kedi';
    pet.irk = fIrk.value.trim();
    pet.dogum = fYil.value ? (fYil.value + (fAy.value ? '-' + ('0' + fAy.value).slice(-2) : '')) : null;
    // Kilo üst sınırı (3 Kas 2026, kullanıcı): gramla yazılan kilo (1350 → 1,35 kg) porsiyonu bozuyordu. Kedi 15, köpek 100 kg.
    var kh = kiloHata(fKilo.value, pet.tur);
    kiloHataGoster(kh);
    if (kh) { fKilo.focus(); return; }
    pet.kilo = num(fKilo.value) ? Math.round(num(fKilo.value) * 10) / 10 : null;
    pet.cinsiyet = getChips(fCinsiyet)[0] || null;
    pet.kisir = fKisir.checked;
    pet.alerji = getChips(fAlerji);
    pet.foto = formFoto || null;

    profile = profile || { v: 1, petler: [] };
    profile.petler = pets();
    var idx = -1;
    profile.petler.forEach(function (p, i) { if (p.id === pet.id) idx = i; });
    if (idx >= 0) profile.petler[idx] = pet; else profile.petler.push(pet);
    seciliId = pet.id;   // kaydedilen dost ekranda seçili açılsın
    try { localStorage.setItem(SEC_LS, seciliId); } catch (er) {}
    persist();
    showList();
  });

  // ---------- Dış API: Hangi Mama? quiz'i buradan profil yazar ----------
  window.PetidiPetProfile = {
    pets: pets,
    // Ürün sayfası yenilenmeden değişince (aroma geçişi, product.js) rozet/davet/boy önerisi yeniden çizilir
    yenidenCiz: function () { renderBadge(); renderInvite(); renderSizeQ(); renderSiklik(); renderCardBadges(); renderReorder(); renderBought(); },
    // Abonelik önerilen sıklık (17 Eki 2026): sepet satırları yerinde yenilenince cart.js çağırır; kutucukta hafta için siklikOneri
    siklikCiz: function () { renderInvite(); renderSiklik(); },
    siklikOneri: siklikOneri,
    dailyGrams: dailyGrams,
    // Teslimat sıklığına üst sınır (21 Eki 2026): [data-hafta-sinir] kabının en büyük haftası (cart.js kutucukta kullanır)
    haftaSiniri: haftaSiniri,
    kapSiniri: kapSiniri,
    // Quiz cevaplarından pet ekler; aynı ad+tür varsa üstüne yazar (çift kayıt olmasın)
    add: function (data) {
      if (!data || !data.ad || !data.tur) return null;
      profile = profile || { v: 1, petler: [] };
      profile.petler = pets();
      var pet = null;
      var adKey = String(data.ad).trim().toLowerCase();
      profile.petler.forEach(function (p) {
        if (p.tur === data.tur && String(p.ad).trim().toLowerCase() === adKey) pet = p;
      });
      if (!pet) {
        pet = { id: 'p' + Date.now().toString(36) + Math.floor(Math.random() * 1e4).toString(36) };
        profile.petler.push(pet);
      }
      pet.ad = String(data.ad).trim();
      pet.tur = data.tur;
      pet.irk = pet.irk || '';
      pet.dogum = data.dogum || pet.dogum || null;
      pet.kilo = data.kilo || pet.kilo || null;
      pet.cinsiyet = pet.cinsiyet || null;
      pet.kisir = !!data.kisir;
      pet.alerji = [].concat(data.alerji || []);
      persist();
      return pet;
    }
  };

  // ---------- Başlangıç ----------
  renderList();
  renderBadge();
  renderInvite();
  renderSizeQ();
  renderSiklik();
  renderCardBadges();
  renderReorder();
  renderBought();
  // Sipariş sonrası yeni sepette attribute kaybolur; profil varsa tazele
  if (pets().length) syncCart();
  // Misafirken oluşturulan profil, giriş yapılınca müşteri kartına taşınsın
  if (boot.loggedIn && pets().length) {
    var serverGuncel = (boot.metafieldJson && boot.metafieldJson.guncelleme) || 0;
    if ((profile.guncelleme || 0) > serverGuncel) syncServer();
  }
})();
